import { render, staticRenderFns } from "./EditDocumentIntervenerComponent.vue?vue&type=template&id=a093ce2e"
import script from "./EditDocumentIntervenerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditDocumentIntervenerComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a093ce2e')) {
      api.createRecord('a093ce2e', component.options)
    } else {
      api.reload('a093ce2e', component.options)
    }
    module.hot.accept("./EditDocumentIntervenerComponent.vue?vue&type=template&id=a093ce2e", function () {
      api.rerender('a093ce2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/components/editDocumentIntervener/EditDocumentIntervenerComponent.vue"
export default component.exports